<button mat-icon-button [matMenuTriggerFor]="filters" [matTooltip]="title">
    <mat-icon>filter_list</mat-icon>
    <span class="red-dot" *ngIf="isFiltering"></span>
</button>
<mat-menu #filters="matMenu" class="filters-panel">
    <div class="wrapper" (click)="$event.stopPropagation()">
        <div class="header">
            <span class="title">{{ title }}</span>
            <a class="tapp-link" (click)="clearFilters()" *ngIf="isFiltering">
                Clear <nb-icon icon="close-outline"></nb-icon>
            </a>
        </div>
        <ng-content></ng-content>
    </div>
</mat-menu>
